// The "⋯" menu on a ticket row: the actions a Sentinel can take on a ticket without opening it.
// Today that is "Assign to me" on a ticket nobody owns. It sits over the row's top-right corner,
// shown on hover or keyboard focus (always on touch screens), so the list stays clean.

import { MoreHorizontal, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface TicketRowMenuProps {
  /** True while this ticket is being assigned. */
  assigning: boolean;
  /** True while any ticket is being assigned: one request at a time. */
  busy: boolean;
  onAssignToMe: () => void;
}

export function TicketRowMenu({
  assigning,
  busy,
  onAssignToMe,
}: TicketRowMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label="Ticket actions"
          className="size-6 rounded-md border border-border bg-white text-gray-700 shadow-sm hover:bg-muted"
        >
          <MoreHorizontal className="size-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        <DropdownMenuItem
          disabled={busy}
          onSelect={onAssignToMe}
          className="gap-2 text-[13px]"
        >
          <UserPlus className="size-3.5" />
          {assigning ? "Assigning…" : "Assign to me"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
